import { Reveal, SectionTag, PageHeader, QuoteCTA } from "../components/Shared";
import { IMG, MANIFESTO } from "../data/content";

const VALUES = [
  { title: "Craftsmanship", body: "We treat a 4-inch decal with the same care as a 40-foot building wrap.", color: "var(--brand-orange)" },
  { title: "Accountability", body: "One team owns your project from first sketch to final install. No finger-pointing, no handoffs.", color: "var(--brand-magenta)" },
  { title: "Speed Without Shortcuts", body: "Rush timelines are part of this industry. We build systems that go fast without cutting corners.", color: "var(--brand-cyan)" },
  { title: "Partnership", body: "We work like an extension of your brand team — proactive, honest, and invested in the result.", color: "var(--brand-lime)" },
];

const CAPABILITIES = ["Grand-format UV flatbed & roll printing", "Dye-sublimation fabric & SEG systems", "CNC routing, laser cutting & metal work", "LED lightbox & channel letter fabrication", "Vehicle, window & environmental graphics", "National multi-location rollout logistics"];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHeader
        tag="About Us"
        title={<>Built in Woodbridge.<br />Trusted Across Ontario.</>}
        subtitle="MSG — Mark Signs & Graphics is a full-service signage and display manufacturer serving brands, retailers, and builders across the Greater Toronto Area and beyond."
      />

      <section className="py-20" data-testid="about-overview-section">
        <div className="msg-container grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <Reveal>
            <div className="img-frame aspect-[4/3] relative">
              <img src={IMG.fabrication} alt="MSG fabrication team at work" loading="lazy" />
              <span className="corner-notch" />
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <SectionTag>Company Overview</SectionTag>
            <h2 className="font-display font-black uppercase tracking-tight text-2xl sm:text-3xl lg:text-4xl mt-5 leading-tight">Sister Concern of AMS Digitals</h2>
            <p className="mt-6 text-base md:text-lg leading-relaxed" style={{ color: "var(--text-2)" }}>
              Born from the same production DNA as AMS Digitals, MSG brings years of combined experience
              in large-format printing, display fabrication, and signage installation to the Canadian market.
            </p>
            <p className="mt-4 text-base md:text-lg leading-relaxed" style={{ color: "var(--text-2)" }}>
              From our facility at 9751 McGillivray Rd in Woodbridge, Ontario, we deliver everything from
              a single storefront sign to national retail rollouts — designed, printed, fabricated, and
              installed by one accountable team.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-20" style={{ background: "var(--bg-2)" }} data-testid="about-capabilities-section">
        <div className="msg-container">
          <Reveal>
            <SectionTag>Experience & Capabilities</SectionTag>
            <h2 className="font-display font-black uppercase tracking-tight text-2xl sm:text-3xl lg:text-4xl mt-5">What We Bring to the Table</h2>
          </Reveal>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px mt-12 border" style={{ borderColor: "var(--line)", background: "var(--line)" }}>
            {CAPABILITIES.map((c, i) => (
              <Reveal key={c} delay={i * 0.06}>
                <div className="p-8 h-full" style={{ background: "var(--bg)" }}>
                  <span className="font-mono text-xs" style={{ color: ["var(--brand-orange)", "var(--brand-magenta)", "var(--brand-cyan)", "var(--brand-lime)"][i % 4] }}>
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <p className="font-display font-bold text-base mt-3">{c}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24" data-testid="about-mission-section">
        <div className="msg-container">
          <Reveal>
            <SectionTag>Mission & Values</SectionTag>
            <h2 className="font-display font-black uppercase tracking-tight text-2xl sm:text-3xl lg:text-4xl mt-5 max-w-2xl leading-tight">
              Make every brand impossible to ignore.
            </h2>
          </Reveal>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
            {VALUES.map((v, i) => (
              <Reveal key={v.title} delay={i * 0.08}>
                <div className="msg-card p-8 h-full relative overflow-hidden">
                  <span className="absolute top-0 left-0 w-full h-1" style={{ background: v.color }} />
                  <h3 className="font-display font-bold uppercase text-lg mt-2">{v.title}</h3>
                  <p className="text-sm mt-4 leading-relaxed" style={{ color: "var(--text-2)" }}>{v.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="pb-24" data-testid="about-manifesto-strip">
        <div className="msg-container flex flex-wrap gap-x-12 gap-y-4 border-t pt-10" style={{ borderColor: "var(--line)" }}>
          {MANIFESTO.map((m, i) => (
            <span key={m.num} className="font-display font-black uppercase text-xl" style={{ color: ["var(--brand-orange)", "var(--brand-magenta)", "var(--brand-cyan)", "var(--brand-lime)"][i] }}>
              {m.num} {m.title}
            </span>
          ))}
        </div>
      </section>

      <QuoteCTA />
    </div>
  );
}
